var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.88,
    cy: 17.73,
    r: 12.16,
    fill: "#ebf7f7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m9.9 14.05 6.49 6.63a2.51 2.51 0 0 0 3.48-.16c.18-.18.45-.5.66-.76l-2.46-2.52-.5.52A.83.83 0 0 1 17 18a.82.82 0 0 1-.57-.24L12.72 14a.79.79 0 0 1 0-1.12l.53-.55-2.47-2.54a8 8 0 0 0-.72.66 2.59 2.59 0 0 0-.16 3.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "teal",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    d: "M15 3a12.44 12.44 0 0 0 0 24.88 12.3 12.3 0 0 0 3.47-.5.8.8 0 1 0-.47-1.54 11 11 0 0 1-3 .43 10.83 10.83 0 1 1 10.75-10.83A10.86 10.86 0 0 1 22.58 23l-1.44-1.44A8.5 8.5 0 0 0 22.3 20a.81.81 0 0 0-.15-.92l-3.51-3.58a.8.8 0 0 0-.57-.24.8.8 0 0 0-.58.25L17 16l-2.57-2.63.53-.54a.81.81 0 0 0 0-1.12l-3.52-3.54A.81.81 0 0 0 10.5 8a10 10 0 0 0-1.6 1.32 4.21 4.21 0 0 0-.15 5.85l6.49 6.64A3.82 3.82 0 0 0 18 23a4.3 4.3 0 0 0 1.85-.46L22 24.66s.08.05.11.08a1 1 0 0 0 .14.09h.42a1 1 0 0 0 .16 0l.26-.16a12.53 12.53 0 0 0 4.21-9.22A12.41 12.41 0 0 0 15 3zm1.38 17.68L9.9 14.05a2.59 2.59 0 0 1 .16-3.6 8 8 0 0 1 .72-.66l2.47 2.52-.53.55a.79.79 0 0 0 0 1.12l3.7 3.78a.81.81 0 0 0 1.15 0l.5-.52 2.46 2.52c-.21.26-.48.58-.66.76a2.51 2.51 0 0 1-3.48.16z",
    className: "icon-teal"
  })));
};
export default SvgCall;